<template>
  <!--begin::Card-->
  <div class="card">
    <!--begin::Card body-->
    <div class="card-body p-0">
      <!--begin::Heading-->
      <div class="card-px text-center py-0 my-10">
        <!--begin::Title-->
        <h2 class="fs-1x fw-bolder">
          {{
            listState === "active" ? "VISITAS ACTIVAS" : "VISITAS CULMINADAS"
          }}
          <i
            :class="
              listState === 'active'
                ? 'fas fa-circle text-success'
                : 'fas fa-circle text-primary'
            "
          ></i>
        </h2>
        <h3
          class="p-6"
          v-if="rol !== 'supervisor' && rol !== 'consultas departamentales'"
        >
          <!-- {{
            nombre_recinto_penitenciario === "TODOS"
              ? ""
              : "CENTRO PENITENCIARIO: "
          }} -->
          {{
            nombre_recinto_penitenciario === "TODOS"
              ? "TODOS LOS RECINTOS PENITENCIARIOS"
              : `CENTRO PENITENCIARIO:${nombre_recinto_penitenciario}`
          }}
          -
          {{
            departamento_centro_penitenciario === "NACIONAL"
              ? "NIVEL NACIONAL"
              : departamento_centro_penitenciario
          }}
        </h3>
        <h3
          class="p-10"
          v-else-if="
            rol === 'supervisor' || rol === 'consultas departamentales'
          "
        >
          SUPERVISIÓN: {{ departamento_supervisar }}
        </h3>
        <p class="text-gray-600 fs-6 fw-bold mb-0">
          <span>
            Información actualizada a : {{ currentDate }}
            <i
              title="Presione para actualizar la tabla"
              class="fas fa-refresh"
              style="font-size: 1.5em; color: teal"
              @click="visitList(listState === 'active' ? 'active' : 'inactive')"
            ></i
          ></span>
        </p>
        <div class="card-header border-0 pt-6">
          <button
            :class="
              listState === 'active' ? 'btn btn-primary' : 'btn btn-success'
            "
            @click="visitList(listState === 'active' ? 'inactive' : 'active')"
          >
            <i
              :class="
                listState === 'active' ? 'fas fa-lock' : 'fas fa-lock-open'
              "
            ></i
            >{{
              listState === "active" ? "Visitas Culminadas" : "Visitas Activas"
            }}
          </button>
        </div>
        <!-- tabla de datos -->
        <div class="card-body pt-0 dropright">
          <DxDataGrid
            id="gridContainer"
            :data-source="listaVisitas"
            key-expr="id_persona_visita"
            :allow-column-reordering="false"
            :allow-column-resizing="true"
            :row-alternation-enabled="false"
            :show-borders="true"
            @exporting="onExporting"
          >
            <DxFilterRow :visible="true" />
            <DxHeaderFilter :visible="true" />
            <DxPager
              :visible="true"
              :allowed-page-sizes="pageSizes"
              :show-page-size-selector="true"
            />
            <DxPaging :page-size="50" />
            <DxGroupPanel :visible="true" />
            <DxGrouping :auto-expand-all="false" />
            <!-- <DxExport :enabled="true" :allow-export-selected-data="true" /> -->
            <DxExport
              v-if="listaVisitas.length > 0"
              :enabled="true"
              :formats="['pdf']"
              >Exportar</DxExport
            >
            <!-- <DxSelection mode="multiple" show-check-boxes-mode="always" /> -->
            <DxColumn
              :width="60"
              :allow-sorting="false"
              :allow-exporting="true"
            />
            <DxColumn
              :width="110"
              :allow-sorting="false"
              :allow-exporting="false"
              caption="Acciones"
              cell-template="cellTemplate"
            />
            <template #cellTemplate="{ data }">
              <span
                type="button"
                :class="
                  listState === 'active'
                    ? 'badge badge-primary'
                    : 'badge badge-success'
                "
                :title="
                  listState === 'active'
                    ? 'Registrar Salida'
                    : 'Información de la Visita'
                "
                @click="registrarSalidaVisita(data.data, listState)"
              >
                <i
                  style="font-size: 1.5em; color: white"
                  :class="
                    listState === 'active'
                      ? 'fas fa-sign-out m-1'
                      : 'fas fa-circle-info m-1'
                  "
                ></i></span
              >&nbsp;
              <!-- <span
                v-if="data.data.cantidad_img < 6"
                type="button"
                class="badge badge-info mt-1"
                title="Capturar Imagen"
                @click="openModalPicture(data.data.id_persona_visita)"
              >
                <i
                  style="font-size: 1.5em; color: white"
                  class="fas fa-camera m-1"
                ></i
              ></span> -->
            </template>
            <DxColumn
              :width="230"
              data-field="fecha_visita_ingreso"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha de Ingreso"
            />
            <DxColumn
              v-if="listState === 'inactive'"
              :width="230"
              data-field="fecha_visita_salida"
              data-type="date"
              :format="formatDateAndHours"
              caption="Fecha Salida de Visita"
            />
            <DxColumn
              :width="285"
              data-field="nombre_visita"
              caption="Nombre Visitante"
            />
            <DxColumn
              :width="130"
              data-field="visita_numero_documento"
              :allow-grouping="false"
              :allow-exporting="false"
              caption="N° Documento"
            />
            <DxColumn
              :width="285"
              data-field="nombre_ppl"
              caption="Nombre PPL"
            />
            <DxColumn
              :width="230"
              data-field="nombre_recinto_penitenciario"
              caption="Recinto Penitenciario"
            />
            <DxColumn
              :width="230"
              data-field="nombre_seccion"
              caption="Sección"
            />
            <DxGroupPanel :visible="true" />
            <DxSearchPanel :visible="true" :highlight-case-sensitive="true" />
            <DxSummary>
              <DxGroupItem
                column="id_visita"
                summary-type="count"
                display-format="{0} Visitas"
              />
              <DxTotalItem
                column="fecha_visita_ingreso"
                summary-type="count"
                display-format="Total visitas: {0}"
              />
            </DxSummary>
            <DxSortByGroupSummaryInfo summary-item="primer_apellido" />
          </DxDataGrid>
        </div>
      </div>
    </div>
  </div>
  <!-- loader -->
  <loading
    v-model:active="isLoading"
    :can-cancel="false"
    :is-full-page="true"
    loader="bars"
    :height="100"
    :width="100"
  ></loading>
  <modalVisitDetails ref="modal" @reload-table="visitList"></modalVisitDetails>
  <pictureCapture ref="modal_camera" @save-image="addImage"></pictureCapture>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { defineComponent, ref, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import visits from "@/visits/composables/useVisits";
import useAuth from "@/auth/composables/useAuth";
import esMessages from "devextreme/localization/messages/es.json";
import { locale, loadMessages } from "devextreme/localization";
import pictureCapture from "@/views/pictures/pictureCapture.vue";
import modalVisitDetails from "@/views/visits/modal_visit_details.vue";
//import { useRoute, useRouter } from "vue-router";
import date from "date-and-time";
import es from "date-and-time/locale/es";
date.locale(es);
import formatDateWithHours from "@/helpers/formatDateWithHours";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import jsPDF from "jspdf";
// import "jspdf-autotable";
import { exportDataGrid } from "devextreme/pdf_exporter";
import img from "../../../public/media/logos/ed002-regpen.png";
import {
  DxDataGrid,
  DxFilterRow,
  DxColumn,
  DxExport,
  //DxSelection,
  DxGroupPanel,
  DxGrouping,
  DxSearchPanel,
  DxPaging,
  DxPager,
  DxSummary,
  DxGroupItem,
  DxSortByGroupSummaryInfo,
  //DxButton,
  DxTotalItem,
  DxHeaderFilter,
} from "devextreme-vue/data-grid";
import "devextreme/dist/css/dx.light.css";
export default defineComponent({
  name: "visits-list",
  components: {
    DxDataGrid,
    DxFilterRow,
    DxColumn,
    DxExport,
    //DxSelection,
    DxGroupPanel,
    DxGrouping,
    DxSearchPanel,
    DxPaging,
    DxPager,
    DxSummary,
    DxGroupItem,
    DxSortByGroupSummaryInfo,
    DxTotalItem,
    DxHeaderFilter,

    Loading,
    modalVisitDetails,
    pictureCapture,
  },
  setup() {
    loadMessages(esMessages);
    locale(navigator.language);
    let currentDate = ref(
      date.format(new Date(), "dddd, DD MMMM YYYY HH:mm:ss")
    );
    const isAdmin = ref(false);
    const isEditor = ref(false);
    const pageSizes = ref([10, 25, 50, 100]);
    let isLoading = ref(false);
    const listaVisitas = ref([]);
    const listState = ref("");
    const Toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 4000,
      timerProgressBar: true,
    });
    const { visitsList, saveImage } = visits();
    const {
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
    } = useAuth();
    const onExporting = async (e) => {
      const doc = new jsPDF("l", "pt", "letter");
      const lastPoint = { x: 0, y: 0 };
      doc.setFontSize(0.1);
      exportDataGrid({
        jsPDFDocument: doc,
        component: e.component,
        indent: 5,
        topLeft: { x: 1, y: 70 },
        customDrawCell: function ({ rect }) {
          if (lastPoint.x < rect.x + rect.w) {
            lastPoint.x = rect.x + rect.w;
          }
          if (lastPoint.y < rect.y + rect.h) {
            lastPoint.y = rect.y + rect.h;
          }
        },
        customizeCell: function (options) {
          const { gridCell, pdfCell } = options;
          if (gridCell.rowType === "data") {
            pdfCell.font = { size: 6 };
          } else if (gridCell.rowType === "header") {
            pdfCell.backgroundColor = "#BEDFE6";
            pdfCell.font = { size: 8 };
          }
        },
      }).then(() => {
        // doc.addImage(img, 50, 20);
        const pageCount = doc.internal.getNumberOfPages();
        for (let i = 1; i <= pageCount; i++) {
          doc.setPage(i);
          const pageSize = doc.internal.pageSize;
          const pageWidth = pageSize.width
            ? pageSize.width
            : pageSize.getWidth();
          const pageHeight = pageSize.height
            ? pageSize.height
            : pageSize.getHeight();
          const pageCurrent = doc.internal.getCurrentPageInfo().pageNumber;
          if (pageCurrent === 1) {
            // Header
            doc.addImage(img, 50, 20);
            const header = `Módulo de Visitas - Sistema Estado Digital ED-4 Régimen Penitenciario   \n ${
              nombre_recinto_penitenciario.value === "TODOS"
                ? "TODOS LOS RECINTOS PENITENCIARIOS"
                : `CENTRO PENITENCIARIO:${nombre_recinto_penitenciario.value}`
            } - ${
              departamento_centro_penitenciario.value === "NACIONAL"
                ? "NIVEL NACIONAL"
                : `DEPARTAMENTO:${departamento_centro_penitenciario.value}`
            }\n ${currentDate.value}`;
            doc.setFont("Helvetica");
            doc.setFontSize(15);
            doc.text(header, 450, 55, {
              baseline: "top",
              align: "center",
            });
          }
          const footer = `Información extraida del Módulo de Visitas del SISTEMA ESTADO DIGITAL ED-4 RÉGIMEN PENITENCIARIO`;
          // Footer
          doc.setFontSize(9);
          doc.setTextColor("#cccccc");
          doc.text(
            footer,
            pageWidth / 1 - doc.getTextWidth(footer) / 1.5,

            pageHeight - 5,
            { baseline: "bottom", align: "right" }
          );

          //pagination
          const pagination = `Página ${i} de ${pageCount}`;
          doc.setFontSize(12);
          doc.text(
            pagination,
            pageWidth / 1 - doc.getTextWidth(pagination) / 0.8,

            pageHeight - 5,
            { baseline: "bottom", align: "left" }
          );
        }
        doc.save("reporte_visitas_ED4.pdf");
      });
    };
    const formatDateAndHours = (date) => {
      if (date === null) {
        return "-.-";
      } else {
        const formattedDate = formatDateWithHours(date);
        return formattedDate;
      }
    };
    const visitList = async (state = "active") => {
      state === "active"
        ? (listState.value = "active")
        : (listState.value = "inactive");
      isLoading.value = true;
      const { data } = await visitsList(state);
      if (data.ok) {
        listaVisitas.value = data.respuesta;
        // listaVisitas.value =  data.respuesta.map((item, index) => {
        //   return { id: index + 1, ...item };
        // });
        isLoading.value = false;
      } else {
        alert("ERROR");
      }
      currentDate.value = date.format(
        new Date(),
        "dddd, DD MMMM YYYY HH:mm:ss"
      );
    };
    const dialog_camera = ref(false);
    const modal_camera = ref(null);
    const openModalPicture = (id_persona_visita) => {
      dialog_camera.value = true;
      modal_camera.value.showModal(dialog_camera.value, id_persona_visita);
    };
    const addImage = async (value) => {
      const { formData, id } = value;
      if (!formData.picture) {
        return;
      } else {
        var arr = formData.picture.split(","),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        const val = new File([u8arr], formData.nameFile, {
          type: mime,
        });
        const { data } = await saveImage({ img: val, id_persona_visita: id });
        if (data) {
          Toast.fire({
            icon: "success",
            title: `Imagen añadida exitosamente`,
          });
          visitList(listState.value);
        } else {
          Toast.fire({
            icon: "error",
            title: `Existió un error, por favor contáctese con el Administrador del Sistema `,
          });
        }
        // state.formData.imagen_segip = value;
        dialog.value = false;
      }
    };
    const dialog = ref(false);
    const modal = ref(null);
    const registrarSalidaVisita = async (data, state) => {
      dialog.value = true;
      modal.value.showModal({
        dialog: dialog.value,
        id_visita: data.id_visita,
        id_persona_visita: data.id_persona_visita,
        state: state,
      });
    };
    onMounted(() => {
      setCurrentPageBreadcrumbs("Lista de visitas a privados de libertad", [
        "Listas",
      ]);
      visitList();
      const userLogged = localStorage.getItem("roles").split(",");
      for (let rol of userLogged) {
        if (rol.toUpperCase() === "ADMIN") {
          isAdmin.value = true;
        } else if (rol.toUpperCase() === "EDITOR") {
          isEditor.value = true;
        }
      }
    });
    // watch(
    //   () => route.params.state,
    //   async (newState) => {
    //     console.log(newState);
    //     if (newState !== "active") {
    //       listState.value = "inactive";
    //     } else {
    //       listState.value = "active";
    //     }
    //     await visitList(newState);
    //   }
    // );
    return {
      isAdmin,
      isEditor,
      isLoading,
      listaVisitas,
      pageSizes,
      registrarSalidaVisita,
      formatDateAndHours,
      currentDate,
      visitList,
      listState,
      rol,
      nombre_recinto_penitenciario,
      departamento_centro_penitenciario,
      departamento_supervisar,
      id_recinto,
      modal,
      dialog,
      dialog_camera,
      modal_camera,
      openModalPicture,
      addImage,
      onExporting,
    };
  },
});
</script>
<style>
/* .swal-wide {
  width: 850px !important;
} */
</style>
